import { render, staticRenderFns } from "./DataImport.vue?vue&type=template&id=3dc1f2bc&"
import script from "./DataImport.vue?vue&type=script&lang=js&"
export * from "./DataImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports